import { useCheckout } from '../../../context/CheckoutContext';
import { usePaymentContext } from '../../../context/PaymentContextProvider';
import { useCartIsBusy } from '../../../hooks/useCartIsBusy';
import { PaymentMethodDto } from '../../../../generated-api';
import CheckoutSidebarContent from './CheckoutSidebarContent';
import classNames from 'classnames';
import { useScreenSize } from '../../../context/ScreenSizeContext';
import { useTotalPrice } from '../../../hooks/useTotalPrice';
import { useCallback } from 'react';
import { useCartStore } from '../../../context/cart/CartStore';
import { useF1NetworkState } from '../../../context/F1NetworkStateStore';

const CheckoutSideBar = () => {
  const { setToDefaultDeliveryMethod, comment, tableNumber, deliveryMethod } = useCheckout();

  const { cartIsEmpty, giftCardPhoneNumber } = useCartStore((state) => ({
    cartIsEmpty: state.cart.orderLines.length < 1,
    giftCardPhoneNumber: state.giftCardPhoneNumber,
  }));

  const { initiatePayment } = usePaymentContext();
  const cartIsBusy = useCartIsBusy();
  const { isPhone } = useScreenSize();
  const totalPrice = useTotalPrice();
  const { vatType } = useCheckout();

  const onSuccess = useCallback(() => {
    setToDefaultDeliveryMethod();
  }, [setToDefaultDeliveryMethod]);

  const handleInitiatePayment = useCallback(
    (paymentMethod: PaymentMethodDto, dynamicFields?: { [key: string]: string }, tipAmount?: number) => {
      if (cartIsEmpty || cartIsBusy) {
        return;
      }

      initiatePayment({
        paymentMethod,
        comment,
        onSuccess,
        tableNumber,
        deliveryMethod,
        dynamicFields,
        giftCardPhoneNumber,
        tipAmount,
        vatType,
      });
    },
    [
      cartIsBusy,
      cartIsEmpty,
      comment,
      deliveryMethod,
      giftCardPhoneNumber,
      initiatePayment,
      onSuccess,
      tableNumber,
      vatType,
    ]
  );

  const className = classNames('desktop:col-span-4 tablet:col-span-4 bg-brand-white flex flex-col overflow-scroll', {
    'h-full': isPhone,
    'h-main': !isPhone,
  });

  return (
    <aside className={className}>
      <CheckoutSidebarContent cartTotalPrice={totalPrice} handleInitiatePayment={handleInitiatePayment} />
    </aside>
  );
};

export default CheckoutSideBar;
